/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/app'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as AuthVerifyOtpRouteImport } from './routes/auth/verify-otp'
import { Route as AuthVerifyMethodRouteImport } from './routes/auth/verify-method'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgotPassword'
import { Route as AuthEmailVerificationRouteImport } from './routes/auth/email-verification'
import { Route as AuthEditNumberRouteImport } from './routes/auth/edit-number'
import { Route as AuthEditEmailRouteImport } from './routes/auth/edit-email'
import { Route as AuthAcceptLegalRouteImport } from './routes/auth/accept-legal'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppSalesRouteImport } from './routes/app/sales'
import { Route as AppReviewsRouteImport } from './routes/app/reviews'
import { Route as AppOnboardingRouteImport } from './routes/app/onboarding'
import { Route as AppAdminRouteImport } from './routes/app/admin'
import { Route as PublicTermsRouteImport } from './routes/_public/terms'
import { Route as PublicPrivacyRouteImport } from './routes/_public/privacy'
import { Route as PublicInvestorConnectRouteImport } from './routes/_public/investor-connect'
import { Route as PublicHowItWorksRouteImport } from './routes/_public/how-it-works'
import { Route as PublicFundraiserConnectRouteImport } from './routes/_public/fundraiser-connect'
import { Route as PublicCookiesPolicyRouteImport } from './routes/_public/cookies-policy'
import { Route as PublicContactRouteImport } from './routes/_public/contact'
import { Route as PublicAboutRouteImport } from './routes/_public/about'
import { Route as AppAdminIndexRouteImport } from './routes/app/admin/index'
import { Route as AppSalesOnboardingJobsRouteImport } from './routes/app/sales/onboarding-jobs'
import { Route as AppCompaniesCompany_idRouteImport } from './routes/app/companies/$company_id'
import { Route as AppAdminWhatsappTemplatesRouteImport } from './routes/app/admin/whatsapp-templates'
import { Route as AppAdminWhatsappGroupsRouteImport } from './routes/app/admin/whatsapp-groups'
import { Route as AppAdminVerificationRouteImport } from './routes/app/admin/verification'
import { Route as AppAdminUsersRouteImport } from './routes/app/admin/users'
import { Route as AppAdminSystemRouteImport } from './routes/app/admin/system'
import { Route as AppAdminSettingsRouteImport } from './routes/app/admin/settings'
import { Route as AppAdminSectionsRouteImport } from './routes/app/admin/sections'
import { Route as AppAdminSalesRouteImport } from './routes/app/admin/sales'
import { Route as AppAdminRolesRouteImport } from './routes/app/admin/roles'
import { Route as AppAdminReviewersRouteImport } from './routes/app/admin/reviewers'
import { Route as AppAdminOnboardingQuestionsRouteImport } from './routes/app/admin/onboarding-questions'
import { Route as AppAdminOnboardingAnswersRouteImport } from './routes/app/admin/onboarding-answers'
import { Route as AppAdminLoginAttemptsRouteImport } from './routes/app/admin/login-attempts'
import { Route as AppAdminLegalRouteImport } from './routes/app/admin/legal'
import { Route as AppAdminInvestorPlatformRouteImport } from './routes/app/admin/investor-platform'
import { Route as AppAdminInvestorOnboardingJobsRouteImport } from './routes/app/admin/investor-onboarding-jobs'
import { Route as AppAdminInvestorInvitesRouteImport } from './routes/app/admin/investor-invites'
import { Route as AppAdminGdprRouteImport } from './routes/app/admin/gdpr'
import { Route as AppAdminFilesRouteImport } from './routes/app/admin/files'
import { Route as AppAdminFeedbackRouteImport } from './routes/app/admin/feedback'
import { Route as AppAdminCompaniesRouteImport } from './routes/app/admin/companies'
import { Route as AppAdminChatRouteImport } from './routes/app/admin/chat'
import { Route as AppAdminAuditLogsRouteImport } from './routes/app/admin/audit-logs'
import { Route as AppAdminAnalyticsRouteImport } from './routes/app/admin/analytics'
import { Route as AppAdminAiUsageRouteImport } from './routes/app/admin/ai-usage'
import { Route as AppSalesOnboardingJobsIndexRouteImport } from './routes/app/sales/onboarding-jobs.index'
import { Route as AppAdminWhatsappGroupsIndexRouteImport } from './routes/app/admin/whatsapp-groups.index'
import { Route as AppAdminUsersIndexRouteImport } from './routes/app/admin/users.index'
import { Route as AppAdminLegalIndexRouteImport } from './routes/app/admin/legal.index'
import { Route as AppAdminInvestorOnboardingJobsIndexRouteImport } from './routes/app/admin/investor-onboarding-jobs.index'
import { Route as AppAdminCompaniesIndexRouteImport } from './routes/app/admin/companies.index'
import { Route as AppSalesOnboardingJobsJob_idRouteImport } from './routes/app/sales/onboarding-jobs.$job_id'
import { Route as AppCompaniesCompany_idOnboardingRouteImport } from './routes/app/companies/$company_id/onboarding'
import { Route as AppAdminWhatsappGroupsGroupIdRouteImport } from './routes/app/admin/whatsapp-groups.$groupId'
import { Route as AppAdminVerificationSettingsRouteImport } from './routes/app/admin/verification.settings'
import { Route as AppAdminVerificationPhoneLogsRouteImport } from './routes/app/admin/verification.phone-logs'
import { Route as AppAdminVerificationEmailLogsRouteImport } from './routes/app/admin/verification.email-logs'
import { Route as AppAdminVerificationAuditLogsRouteImport } from './routes/app/admin/verification.audit-logs'
import { Route as AppAdminUsersUser_idRouteImport } from './routes/app/admin/users.$user_id'
import { Route as AppAdminLegalNewRouteImport } from './routes/app/admin/legal.new'
import { Route as AppAdminLegalAcknowledgementsRouteImport } from './routes/app/admin/legal.acknowledgements'
import { Route as AppAdminLegalDocument_idRouteImport } from './routes/app/admin/legal.$document_id'
import { Route as AppAdminInvestorOnboardingJobsJob_idRouteImport } from './routes/app/admin/investor-onboarding-jobs.$job_id'
import { Route as AppAdminCompaniesCompany_idRouteImport } from './routes/app/admin/companies.$company_id'
import { Route as AppCompaniesCompany_idOnboardingIndexRouteImport } from './routes/app/companies/$company_id/onboarding/index'
import { Route as AppCompaniesCompany_idSectionsSection_idRouteImport } from './routes/app/companies/$company_id/sections/$section_id'
import { Route as AppCompaniesCompany_idOnboardingSummaryRouteImport } from './routes/app/companies/$company_id/onboarding/summary'
import { Route as AppCompaniesCompany_idSectionsSection_idNewRouteImport } from './routes/app/companies/$company_id/sections/$section_id/new'
import { Route as AppCompaniesCompany_idSectionsSection_idDashboardRouteImport } from './routes/app/companies/$company_id/sections/$section_id/dashboard'
import { Route as AppCompaniesCompany_idSectionsSection_idThreadsThread_idRouteImport } from './routes/app/companies/$company_id/sections/$section_id/threads/$thread_id'
import { Route as AppCompaniesCompany_idSectionsSection_idInvestorChatThread_idRouteImport } from './routes/app/companies/$company_id/sections/$section_id/investor-chat/$thread_id'

const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const AuthVerifyOtpRoute = AuthVerifyOtpRouteImport.update({
  id: '/verify-otp',
  path: '/verify-otp',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVerifyMethodRoute = AuthVerifyMethodRouteImport.update({
  id: '/verify-method',
  path: '/verify-method',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgotPassword',
  path: '/forgotPassword',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEmailVerificationRoute = AuthEmailVerificationRouteImport.update({
  id: '/email-verification',
  path: '/email-verification',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEditNumberRoute = AuthEditNumberRouteImport.update({
  id: '/edit-number',
  path: '/edit-number',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEditEmailRoute = AuthEditEmailRouteImport.update({
  id: '/edit-email',
  path: '/edit-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAcceptLegalRoute = AuthAcceptLegalRouteImport.update({
  id: '/accept-legal',
  path: '/accept-legal',
  getParentRoute: () => AuthRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesRoute = AppSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AppRoute,
} as any)
const AppReviewsRoute = AppReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const PublicTermsRoute = PublicTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => PublicRoute,
} as any)
const PublicPrivacyRoute = PublicPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => PublicRoute,
} as any)
const PublicInvestorConnectRoute = PublicInvestorConnectRouteImport.update({
  id: '/investor-connect',
  path: '/investor-connect',
  getParentRoute: () => PublicRoute,
} as any)
const PublicHowItWorksRoute = PublicHowItWorksRouteImport.update({
  id: '/how-it-works',
  path: '/how-it-works',
  getParentRoute: () => PublicRoute,
} as any)
const PublicFundraiserConnectRoute = PublicFundraiserConnectRouteImport.update({
  id: '/fundraiser-connect',
  path: '/fundraiser-connect',
  getParentRoute: () => PublicRoute,
} as any)
const PublicCookiesPolicyRoute = PublicCookiesPolicyRouteImport.update({
  id: '/cookies-policy',
  path: '/cookies-policy',
  getParentRoute: () => PublicRoute,
} as any)
const PublicContactRoute = PublicContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAboutRoute = PublicAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => PublicRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppSalesOnboardingJobsRoute = AppSalesOnboardingJobsRouteImport.update({
  id: '/onboarding-jobs',
  path: '/onboarding-jobs',
  getParentRoute: () => AppSalesRoute,
} as any)
const AppCompaniesCompany_idRoute = AppCompaniesCompany_idRouteImport.update({
  id: '/companies/$company_id',
  path: '/companies/$company_id',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminWhatsappTemplatesRoute =
  AppAdminWhatsappTemplatesRouteImport.update({
    id: '/whatsapp-templates',
    path: '/whatsapp-templates',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminWhatsappGroupsRoute = AppAdminWhatsappGroupsRouteImport.update({
  id: '/whatsapp-groups',
  path: '/whatsapp-groups',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminVerificationRoute = AppAdminVerificationRouteImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSystemRoute = AppAdminSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSettingsRoute = AppAdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSectionsRoute = AppAdminSectionsRouteImport.update({
  id: '/sections',
  path: '/sections',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSalesRoute = AppAdminSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminRolesRoute = AppAdminRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminReviewersRoute = AppAdminReviewersRouteImport.update({
  id: '/reviewers',
  path: '/reviewers',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminOnboardingQuestionsRoute =
  AppAdminOnboardingQuestionsRouteImport.update({
    id: '/onboarding-questions',
    path: '/onboarding-questions',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminOnboardingAnswersRoute =
  AppAdminOnboardingAnswersRouteImport.update({
    id: '/onboarding-answers',
    path: '/onboarding-answers',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminLoginAttemptsRoute = AppAdminLoginAttemptsRouteImport.update({
  id: '/login-attempts',
  path: '/login-attempts',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminLegalRoute = AppAdminLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminInvestorPlatformRoute =
  AppAdminInvestorPlatformRouteImport.update({
    id: '/investor-platform',
    path: '/investor-platform',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminInvestorOnboardingJobsRoute =
  AppAdminInvestorOnboardingJobsRouteImport.update({
    id: '/investor-onboarding-jobs',
    path: '/investor-onboarding-jobs',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminInvestorInvitesRoute = AppAdminInvestorInvitesRouteImport.update({
  id: '/investor-invites',
  path: '/investor-invites',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminGdprRoute = AppAdminGdprRouteImport.update({
  id: '/gdpr',
  path: '/gdpr',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminFilesRoute = AppAdminFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminFeedbackRoute = AppAdminFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminCompaniesRoute = AppAdminCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminChatRoute = AppAdminChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAuditLogsRoute = AppAdminAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAnalyticsRoute = AppAdminAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAiUsageRoute = AppAdminAiUsageRouteImport.update({
  id: '/ai-usage',
  path: '/ai-usage',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppSalesOnboardingJobsIndexRoute =
  AppSalesOnboardingJobsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSalesOnboardingJobsRoute,
  } as any)
const AppAdminWhatsappGroupsIndexRoute =
  AppAdminWhatsappGroupsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminWhatsappGroupsRoute,
  } as any)
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminUsersRoute,
} as any)
const AppAdminLegalIndexRoute = AppAdminLegalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminLegalRoute,
} as any)
const AppAdminInvestorOnboardingJobsIndexRoute =
  AppAdminInvestorOnboardingJobsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminInvestorOnboardingJobsRoute,
  } as any)
const AppAdminCompaniesIndexRoute = AppAdminCompaniesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminCompaniesRoute,
} as any)
const AppSalesOnboardingJobsJob_idRoute =
  AppSalesOnboardingJobsJob_idRouteImport.update({
    id: '/$job_id',
    path: '/$job_id',
    getParentRoute: () => AppSalesOnboardingJobsRoute,
  } as any)
const AppCompaniesCompany_idOnboardingRoute =
  AppCompaniesCompany_idOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AppCompaniesCompany_idRoute,
  } as any)
const AppAdminWhatsappGroupsGroupIdRoute =
  AppAdminWhatsappGroupsGroupIdRouteImport.update({
    id: '/$groupId',
    path: '/$groupId',
    getParentRoute: () => AppAdminWhatsappGroupsRoute,
  } as any)
const AppAdminVerificationSettingsRoute =
  AppAdminVerificationSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppAdminVerificationRoute,
  } as any)
const AppAdminVerificationPhoneLogsRoute =
  AppAdminVerificationPhoneLogsRouteImport.update({
    id: '/phone-logs',
    path: '/phone-logs',
    getParentRoute: () => AppAdminVerificationRoute,
  } as any)
const AppAdminVerificationEmailLogsRoute =
  AppAdminVerificationEmailLogsRouteImport.update({
    id: '/email-logs',
    path: '/email-logs',
    getParentRoute: () => AppAdminVerificationRoute,
  } as any)
const AppAdminVerificationAuditLogsRoute =
  AppAdminVerificationAuditLogsRouteImport.update({
    id: '/audit-logs',
    path: '/audit-logs',
    getParentRoute: () => AppAdminVerificationRoute,
  } as any)
const AppAdminUsersUser_idRoute = AppAdminUsersUser_idRouteImport.update({
  id: '/$user_id',
  path: '/$user_id',
  getParentRoute: () => AppAdminUsersRoute,
} as any)
const AppAdminLegalNewRoute = AppAdminLegalNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminLegalRoute,
} as any)
const AppAdminLegalAcknowledgementsRoute =
  AppAdminLegalAcknowledgementsRouteImport.update({
    id: '/acknowledgements',
    path: '/acknowledgements',
    getParentRoute: () => AppAdminLegalRoute,
  } as any)
const AppAdminLegalDocument_idRoute =
  AppAdminLegalDocument_idRouteImport.update({
    id: '/$document_id',
    path: '/$document_id',
    getParentRoute: () => AppAdminLegalRoute,
  } as any)
const AppAdminInvestorOnboardingJobsJob_idRoute =
  AppAdminInvestorOnboardingJobsJob_idRouteImport.update({
    id: '/$job_id',
    path: '/$job_id',
    getParentRoute: () => AppAdminInvestorOnboardingJobsRoute,
  } as any)
const AppAdminCompaniesCompany_idRoute =
  AppAdminCompaniesCompany_idRouteImport.update({
    id: '/$company_id',
    path: '/$company_id',
    getParentRoute: () => AppAdminCompaniesRoute,
  } as any)
const AppCompaniesCompany_idOnboardingIndexRoute =
  AppCompaniesCompany_idOnboardingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCompaniesCompany_idOnboardingRoute,
  } as any)
const AppCompaniesCompany_idSectionsSection_idRoute =
  AppCompaniesCompany_idSectionsSection_idRouteImport.update({
    id: '/sections/$section_id',
    path: '/sections/$section_id',
    getParentRoute: () => AppCompaniesCompany_idRoute,
  } as any)
const AppCompaniesCompany_idOnboardingSummaryRoute =
  AppCompaniesCompany_idOnboardingSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => AppCompaniesCompany_idOnboardingRoute,
  } as any)
const AppCompaniesCompany_idSectionsSection_idNewRoute =
  AppCompaniesCompany_idSectionsSection_idNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppCompaniesCompany_idSectionsSection_idRoute,
  } as any)
const AppCompaniesCompany_idSectionsSection_idDashboardRoute =
  AppCompaniesCompany_idSectionsSection_idDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AppCompaniesCompany_idSectionsSection_idRoute,
  } as any)
const AppCompaniesCompany_idSectionsSection_idThreadsThread_idRoute =
  AppCompaniesCompany_idSectionsSection_idThreadsThread_idRouteImport.update({
    id: '/threads/$thread_id',
    path: '/threads/$thread_id',
    getParentRoute: () => AppCompaniesCompany_idSectionsSection_idRoute,
  } as any)
const AppCompaniesCompany_idSectionsSection_idInvestorChatThread_idRoute =
  AppCompaniesCompany_idSectionsSection_idInvestorChatThread_idRouteImport.update(
    {
      id: '/investor-chat/$thread_id',
      path: '/investor-chat/$thread_id',
      getParentRoute: () => AppCompaniesCompany_idSectionsSection_idRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/app': typeof AppRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/about': typeof PublicAboutRoute
  '/contact': typeof PublicContactRoute
  '/cookies-policy': typeof PublicCookiesPolicyRoute
  '/fundraiser-connect': typeof PublicFundraiserConnectRoute
  '/how-it-works': typeof PublicHowItWorksRoute
  '/investor-connect': typeof PublicInvestorConnectRoute
  '/privacy': typeof PublicPrivacyRoute
  '/terms': typeof PublicTermsRoute
  '/app/admin': typeof AppAdminRouteWithChildren
  '/app/onboarding': typeof AppOnboardingRoute
  '/app/reviews': typeof AppReviewsRoute
  '/app/sales': typeof AppSalesRouteWithChildren
  '/app/settings': typeof AppSettingsRoute
  '/auth/accept-legal': typeof AuthAcceptLegalRoute
  '/auth/edit-email': typeof AuthEditEmailRoute
  '/auth/edit-number': typeof AuthEditNumberRoute
  '/auth/email-verification': typeof AuthEmailVerificationRoute
  '/auth/forgotPassword': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify-method': typeof AuthVerifyMethodRoute
  '/auth/verify-otp': typeof AuthVerifyOtpRoute
  '/': typeof PublicIndexRoute
  '/app/': typeof AppIndexRoute
  '/app/admin/ai-usage': typeof AppAdminAiUsageRoute
  '/app/admin/analytics': typeof AppAdminAnalyticsRoute
  '/app/admin/audit-logs': typeof AppAdminAuditLogsRoute
  '/app/admin/chat': typeof AppAdminChatRoute
  '/app/admin/companies': typeof AppAdminCompaniesRouteWithChildren
  '/app/admin/feedback': typeof AppAdminFeedbackRoute
  '/app/admin/files': typeof AppAdminFilesRoute
  '/app/admin/gdpr': typeof AppAdminGdprRoute
  '/app/admin/investor-invites': typeof AppAdminInvestorInvitesRoute
  '/app/admin/investor-onboarding-jobs': typeof AppAdminInvestorOnboardingJobsRouteWithChildren
  '/app/admin/investor-platform': typeof AppAdminInvestorPlatformRoute
  '/app/admin/legal': typeof AppAdminLegalRouteWithChildren
  '/app/admin/login-attempts': typeof AppAdminLoginAttemptsRoute
  '/app/admin/onboarding-answers': typeof AppAdminOnboardingAnswersRoute
  '/app/admin/onboarding-questions': typeof AppAdminOnboardingQuestionsRoute
  '/app/admin/reviewers': typeof AppAdminReviewersRoute
  '/app/admin/roles': typeof AppAdminRolesRoute
  '/app/admin/sales': typeof AppAdminSalesRoute
  '/app/admin/sections': typeof AppAdminSectionsRoute
  '/app/admin/settings': typeof AppAdminSettingsRoute
  '/app/admin/system': typeof AppAdminSystemRoute
  '/app/admin/users': typeof AppAdminUsersRouteWithChildren
  '/app/admin/verification': typeof AppAdminVerificationRouteWithChildren
  '/app/admin/whatsapp-groups': typeof AppAdminWhatsappGroupsRouteWithChildren
  '/app/admin/whatsapp-templates': typeof AppAdminWhatsappTemplatesRoute
  '/app/companies/$company_id': typeof AppCompaniesCompany_idRouteWithChildren
  '/app/sales/onboarding-jobs': typeof AppSalesOnboardingJobsRouteWithChildren
  '/app/admin/': typeof AppAdminIndexRoute
  '/app/admin/companies/$company_id': typeof AppAdminCompaniesCompany_idRoute
  '/app/admin/investor-onboarding-jobs/$job_id': typeof AppAdminInvestorOnboardingJobsJob_idRoute
  '/app/admin/legal/$document_id': typeof AppAdminLegalDocument_idRoute
  '/app/admin/legal/acknowledgements': typeof AppAdminLegalAcknowledgementsRoute
  '/app/admin/legal/new': typeof AppAdminLegalNewRoute
  '/app/admin/users/$user_id': typeof AppAdminUsersUser_idRoute
  '/app/admin/verification/audit-logs': typeof AppAdminVerificationAuditLogsRoute
  '/app/admin/verification/email-logs': typeof AppAdminVerificationEmailLogsRoute
  '/app/admin/verification/phone-logs': typeof AppAdminVerificationPhoneLogsRoute
  '/app/admin/verification/settings': typeof AppAdminVerificationSettingsRoute
  '/app/admin/whatsapp-groups/$groupId': typeof AppAdminWhatsappGroupsGroupIdRoute
  '/app/companies/$company_id/onboarding': typeof AppCompaniesCompany_idOnboardingRouteWithChildren
  '/app/sales/onboarding-jobs/$job_id': typeof AppSalesOnboardingJobsJob_idRoute
  '/app/admin/companies/': typeof AppAdminCompaniesIndexRoute
  '/app/admin/investor-onboarding-jobs/': typeof AppAdminInvestorOnboardingJobsIndexRoute
  '/app/admin/legal/': typeof AppAdminLegalIndexRoute
  '/app/admin/users/': typeof AppAdminUsersIndexRoute
  '/app/admin/whatsapp-groups/': typeof AppAdminWhatsappGroupsIndexRoute
  '/app/sales/onboarding-jobs/': typeof AppSalesOnboardingJobsIndexRoute
  '/app/companies/$company_id/onboarding/summary': typeof AppCompaniesCompany_idOnboardingSummaryRoute
  '/app/companies/$company_id/sections/$section_id': typeof AppCompaniesCompany_idSectionsSection_idRouteWithChildren
  '/app/companies/$company_id/onboarding/': typeof AppCompaniesCompany_idOnboardingIndexRoute
  '/app/companies/$company_id/sections/$section_id/dashboard': typeof AppCompaniesCompany_idSectionsSection_idDashboardRoute
  '/app/companies/$company_id/sections/$section_id/new': typeof AppCompaniesCompany_idSectionsSection_idNewRoute
  '/app/companies/$company_id/sections/$section_id/investor-chat/$thread_id': typeof AppCompaniesCompany_idSectionsSection_idInvestorChatThread_idRoute
  '/app/companies/$company_id/sections/$section_id/threads/$thread_id': typeof AppCompaniesCompany_idSectionsSection_idThreadsThread_idRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteWithChildren
  '/about': typeof PublicAboutRoute
  '/contact': typeof PublicContactRoute
  '/cookies-policy': typeof PublicCookiesPolicyRoute
  '/fundraiser-connect': typeof PublicFundraiserConnectRoute
  '/how-it-works': typeof PublicHowItWorksRoute
  '/investor-connect': typeof PublicInvestorConnectRoute
  '/privacy': typeof PublicPrivacyRoute
  '/terms': typeof PublicTermsRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/app/reviews': typeof AppReviewsRoute
  '/app/sales': typeof AppSalesRouteWithChildren
  '/app/settings': typeof AppSettingsRoute
  '/auth/accept-legal': typeof AuthAcceptLegalRoute
  '/auth/edit-email': typeof AuthEditEmailRoute
  '/auth/edit-number': typeof AuthEditNumberRoute
  '/auth/email-verification': typeof AuthEmailVerificationRoute
  '/auth/forgotPassword': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify-method': typeof AuthVerifyMethodRoute
  '/auth/verify-otp': typeof AuthVerifyOtpRoute
  '/': typeof PublicIndexRoute
  '/app': typeof AppIndexRoute
  '/app/admin/ai-usage': typeof AppAdminAiUsageRoute
  '/app/admin/analytics': typeof AppAdminAnalyticsRoute
  '/app/admin/audit-logs': typeof AppAdminAuditLogsRoute
  '/app/admin/chat': typeof AppAdminChatRoute
  '/app/admin/feedback': typeof AppAdminFeedbackRoute
  '/app/admin/files': typeof AppAdminFilesRoute
  '/app/admin/gdpr': typeof AppAdminGdprRoute
  '/app/admin/investor-invites': typeof AppAdminInvestorInvitesRoute
  '/app/admin/investor-platform': typeof AppAdminInvestorPlatformRoute
  '/app/admin/login-attempts': typeof AppAdminLoginAttemptsRoute
  '/app/admin/onboarding-answers': typeof AppAdminOnboardingAnswersRoute
  '/app/admin/onboarding-questions': typeof AppAdminOnboardingQuestionsRoute
  '/app/admin/reviewers': typeof AppAdminReviewersRoute
  '/app/admin/roles': typeof AppAdminRolesRoute
  '/app/admin/sales': typeof AppAdminSalesRoute
  '/app/admin/sections': typeof AppAdminSectionsRoute
  '/app/admin/settings': typeof AppAdminSettingsRoute
  '/app/admin/system': typeof AppAdminSystemRoute
  '/app/admin/verification': typeof AppAdminVerificationRouteWithChildren
  '/app/admin/whatsapp-templates': typeof AppAdminWhatsappTemplatesRoute
  '/app/companies/$company_id': typeof AppCompaniesCompany_idRouteWithChildren
  '/app/admin': typeof AppAdminIndexRoute
  '/app/admin/companies/$company_id': typeof AppAdminCompaniesCompany_idRoute
  '/app/admin/investor-onboarding-jobs/$job_id': typeof AppAdminInvestorOnboardingJobsJob_idRoute
  '/app/admin/legal/$document_id': typeof AppAdminLegalDocument_idRoute
  '/app/admin/legal/acknowledgements': typeof AppAdminLegalAcknowledgementsRoute
  '/app/admin/legal/new': typeof AppAdminLegalNewRoute
  '/app/admin/users/$user_id': typeof AppAdminUsersUser_idRoute
  '/app/admin/verification/audit-logs': typeof AppAdminVerificationAuditLogsRoute
  '/app/admin/verification/email-logs': typeof AppAdminVerificationEmailLogsRoute
  '/app/admin/verification/phone-logs': typeof AppAdminVerificationPhoneLogsRoute
  '/app/admin/verification/settings': typeof AppAdminVerificationSettingsRoute
  '/app/admin/whatsapp-groups/$groupId': typeof AppAdminWhatsappGroupsGroupIdRoute
  '/app/sales/onboarding-jobs/$job_id': typeof AppSalesOnboardingJobsJob_idRoute
  '/app/admin/companies': typeof AppAdminCompaniesIndexRoute
  '/app/admin/investor-onboarding-jobs': typeof AppAdminInvestorOnboardingJobsIndexRoute
  '/app/admin/legal': typeof AppAdminLegalIndexRoute
  '/app/admin/users': typeof AppAdminUsersIndexRoute
  '/app/admin/whatsapp-groups': typeof AppAdminWhatsappGroupsIndexRoute
  '/app/sales/onboarding-jobs': typeof AppSalesOnboardingJobsIndexRoute
  '/app/companies/$company_id/onboarding/summary': typeof AppCompaniesCompany_idOnboardingSummaryRoute
  '/app/companies/$company_id/sections/$section_id': typeof AppCompaniesCompany_idSectionsSection_idRouteWithChildren
  '/app/companies/$company_id/onboarding': typeof AppCompaniesCompany_idOnboardingIndexRoute
  '/app/companies/$company_id/sections/$section_id/dashboard': typeof AppCompaniesCompany_idSectionsSection_idDashboardRoute
  '/app/companies/$company_id/sections/$section_id/new': typeof AppCompaniesCompany_idSectionsSection_idNewRoute
  '/app/companies/$company_id/sections/$section_id/investor-chat/$thread_id': typeof AppCompaniesCompany_idSectionsSection_idInvestorChatThread_idRoute
  '/app/companies/$company_id/sections/$section_id/threads/$thread_id': typeof AppCompaniesCompany_idSectionsSection_idThreadsThread_idRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_public': typeof PublicRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/_public/about': typeof PublicAboutRoute
  '/_public/contact': typeof PublicContactRoute
  '/_public/cookies-policy': typeof PublicCookiesPolicyRoute
  '/_public/fundraiser-connect': typeof PublicFundraiserConnectRoute
  '/_public/how-it-works': typeof PublicHowItWorksRoute
  '/_public/investor-connect': typeof PublicInvestorConnectRoute
  '/_public/privacy': typeof PublicPrivacyRoute
  '/_public/terms': typeof PublicTermsRoute
  '/app/admin': typeof AppAdminRouteWithChildren
  '/app/onboarding': typeof AppOnboardingRoute
  '/app/reviews': typeof AppReviewsRoute
  '/app/sales': typeof AppSalesRouteWithChildren
  '/app/settings': typeof AppSettingsRoute
  '/auth/accept-legal': typeof AuthAcceptLegalRoute
  '/auth/edit-email': typeof AuthEditEmailRoute
  '/auth/edit-number': typeof AuthEditNumberRoute
  '/auth/email-verification': typeof AuthEmailVerificationRoute
  '/auth/forgotPassword': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify-method': typeof AuthVerifyMethodRoute
  '/auth/verify-otp': typeof AuthVerifyOtpRoute
  '/_public/': typeof PublicIndexRoute
  '/app/': typeof AppIndexRoute
  '/app/admin/ai-usage': typeof AppAdminAiUsageRoute
  '/app/admin/analytics': typeof AppAdminAnalyticsRoute
  '/app/admin/audit-logs': typeof AppAdminAuditLogsRoute
  '/app/admin/chat': typeof AppAdminChatRoute
  '/app/admin/companies': typeof AppAdminCompaniesRouteWithChildren
  '/app/admin/feedback': typeof AppAdminFeedbackRoute
  '/app/admin/files': typeof AppAdminFilesRoute
  '/app/admin/gdpr': typeof AppAdminGdprRoute
  '/app/admin/investor-invites': typeof AppAdminInvestorInvitesRoute
  '/app/admin/investor-onboarding-jobs': typeof AppAdminInvestorOnboardingJobsRouteWithChildren
  '/app/admin/investor-platform': typeof AppAdminInvestorPlatformRoute
  '/app/admin/legal': typeof AppAdminLegalRouteWithChildren
  '/app/admin/login-attempts': typeof AppAdminLoginAttemptsRoute
  '/app/admin/onboarding-answers': typeof AppAdminOnboardingAnswersRoute
  '/app/admin/onboarding-questions': typeof AppAdminOnboardingQuestionsRoute
  '/app/admin/reviewers': typeof AppAdminReviewersRoute
  '/app/admin/roles': typeof AppAdminRolesRoute
  '/app/admin/sales': typeof AppAdminSalesRoute
  '/app/admin/sections': typeof AppAdminSectionsRoute
  '/app/admin/settings': typeof AppAdminSettingsRoute
  '/app/admin/system': typeof AppAdminSystemRoute
  '/app/admin/users': typeof AppAdminUsersRouteWithChildren
  '/app/admin/verification': typeof AppAdminVerificationRouteWithChildren
  '/app/admin/whatsapp-groups': typeof AppAdminWhatsappGroupsRouteWithChildren
  '/app/admin/whatsapp-templates': typeof AppAdminWhatsappTemplatesRoute
  '/app/companies/$company_id': typeof AppCompaniesCompany_idRouteWithChildren
  '/app/sales/onboarding-jobs': typeof AppSalesOnboardingJobsRouteWithChildren
  '/app/admin/': typeof AppAdminIndexRoute
  '/app/admin/companies/$company_id': typeof AppAdminCompaniesCompany_idRoute
  '/app/admin/investor-onboarding-jobs/$job_id': typeof AppAdminInvestorOnboardingJobsJob_idRoute
  '/app/admin/legal/$document_id': typeof AppAdminLegalDocument_idRoute
  '/app/admin/legal/acknowledgements': typeof AppAdminLegalAcknowledgementsRoute
  '/app/admin/legal/new': typeof AppAdminLegalNewRoute
  '/app/admin/users/$user_id': typeof AppAdminUsersUser_idRoute
  '/app/admin/verification/audit-logs': typeof AppAdminVerificationAuditLogsRoute
  '/app/admin/verification/email-logs': typeof AppAdminVerificationEmailLogsRoute
  '/app/admin/verification/phone-logs': typeof AppAdminVerificationPhoneLogsRoute
  '/app/admin/verification/settings': typeof AppAdminVerificationSettingsRoute
  '/app/admin/whatsapp-groups/$groupId': typeof AppAdminWhatsappGroupsGroupIdRoute
  '/app/companies/$company_id/onboarding': typeof AppCompaniesCompany_idOnboardingRouteWithChildren
  '/app/sales/onboarding-jobs/$job_id': typeof AppSalesOnboardingJobsJob_idRoute
  '/app/admin/companies/': typeof AppAdminCompaniesIndexRoute
  '/app/admin/investor-onboarding-jobs/': typeof AppAdminInvestorOnboardingJobsIndexRoute
  '/app/admin/legal/': typeof AppAdminLegalIndexRoute
  '/app/admin/users/': typeof AppAdminUsersIndexRoute
  '/app/admin/whatsapp-groups/': typeof AppAdminWhatsappGroupsIndexRoute
  '/app/sales/onboarding-jobs/': typeof AppSalesOnboardingJobsIndexRoute
  '/app/companies/$company_id/onboarding/summary': typeof AppCompaniesCompany_idOnboardingSummaryRoute
  '/app/companies/$company_id/sections/$section_id': typeof AppCompaniesCompany_idSectionsSection_idRouteWithChildren
  '/app/companies/$company_id/onboarding/': typeof AppCompaniesCompany_idOnboardingIndexRoute
  '/app/companies/$company_id/sections/$section_id/dashboard': typeof AppCompaniesCompany_idSectionsSection_idDashboardRoute
  '/app/companies/$company_id/sections/$section_id/new': typeof AppCompaniesCompany_idSectionsSection_idNewRoute
  '/app/companies/$company_id/sections/$section_id/investor-chat/$thread_id': typeof AppCompaniesCompany_idSectionsSection_idInvestorChatThread_idRoute
  '/app/companies/$company_id/sections/$section_id/threads/$thread_id': typeof AppCompaniesCompany_idSectionsSection_idThreadsThread_idRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/app'
    | '/auth'
    | '/about'
    | '/contact'
    | '/cookies-policy'
    | '/fundraiser-connect'
    | '/how-it-works'
    | '/investor-connect'
    | '/privacy'
    | '/terms'
    | '/app/admin'
    | '/app/onboarding'
    | '/app/reviews'
    | '/app/sales'
    | '/app/settings'
    | '/auth/accept-legal'
    | '/auth/edit-email'
    | '/auth/edit-number'
    | '/auth/email-verification'
    | '/auth/forgotPassword'
    | '/auth/login'
    | '/auth/reset-password'
    | '/auth/signup'
    | '/auth/verify-method'
    | '/auth/verify-otp'
    | '/'
    | '/app/'
    | '/app/admin/ai-usage'
    | '/app/admin/analytics'
    | '/app/admin/audit-logs'
    | '/app/admin/chat'
    | '/app/admin/companies'
    | '/app/admin/feedback'
    | '/app/admin/files'
    | '/app/admin/gdpr'
    | '/app/admin/investor-invites'
    | '/app/admin/investor-onboarding-jobs'
    | '/app/admin/investor-platform'
    | '/app/admin/legal'
    | '/app/admin/login-attempts'
    | '/app/admin/onboarding-answers'
    | '/app/admin/onboarding-questions'
    | '/app/admin/reviewers'
    | '/app/admin/roles'
    | '/app/admin/sales'
    | '/app/admin/sections'
    | '/app/admin/settings'
    | '/app/admin/system'
    | '/app/admin/users'
    | '/app/admin/verification'
    | '/app/admin/whatsapp-groups'
    | '/app/admin/whatsapp-templates'
    | '/app/companies/$company_id'
    | '/app/sales/onboarding-jobs'
    | '/app/admin/'
    | '/app/admin/companies/$company_id'
    | '/app/admin/investor-onboarding-jobs/$job_id'
    | '/app/admin/legal/$document_id'
    | '/app/admin/legal/acknowledgements'
    | '/app/admin/legal/new'
    | '/app/admin/users/$user_id'
    | '/app/admin/verification/audit-logs'
    | '/app/admin/verification/email-logs'
    | '/app/admin/verification/phone-logs'
    | '/app/admin/verification/settings'
    | '/app/admin/whatsapp-groups/$groupId'
    | '/app/companies/$company_id/onboarding'
    | '/app/sales/onboarding-jobs/$job_id'
    | '/app/admin/companies/'
    | '/app/admin/investor-onboarding-jobs/'
    | '/app/admin/legal/'
    | '/app/admin/users/'
    | '/app/admin/whatsapp-groups/'
    | '/app/sales/onboarding-jobs/'
    | '/app/companies/$company_id/onboarding/summary'
    | '/app/companies/$company_id/sections/$section_id'
    | '/app/companies/$company_id/onboarding/'
    | '/app/companies/$company_id/sections/$section_id/dashboard'
    | '/app/companies/$company_id/sections/$section_id/new'
    | '/app/companies/$company_id/sections/$section_id/investor-chat/$thread_id'
    | '/app/companies/$company_id/sections/$section_id/threads/$thread_id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/about'
    | '/contact'
    | '/cookies-policy'
    | '/fundraiser-connect'
    | '/how-it-works'
    | '/investor-connect'
    | '/privacy'
    | '/terms'
    | '/app/onboarding'
    | '/app/reviews'
    | '/app/sales'
    | '/app/settings'
    | '/auth/accept-legal'
    | '/auth/edit-email'
    | '/auth/edit-number'
    | '/auth/email-verification'
    | '/auth/forgotPassword'
    | '/auth/login'
    | '/auth/reset-password'
    | '/auth/signup'
    | '/auth/verify-method'
    | '/auth/verify-otp'
    | '/'
    | '/app'
    | '/app/admin/ai-usage'
    | '/app/admin/analytics'
    | '/app/admin/audit-logs'
    | '/app/admin/chat'
    | '/app/admin/feedback'
    | '/app/admin/files'
    | '/app/admin/gdpr'
    | '/app/admin/investor-invites'
    | '/app/admin/investor-platform'
    | '/app/admin/login-attempts'
    | '/app/admin/onboarding-answers'
    | '/app/admin/onboarding-questions'
    | '/app/admin/reviewers'
    | '/app/admin/roles'
    | '/app/admin/sales'
    | '/app/admin/sections'
    | '/app/admin/settings'
    | '/app/admin/system'
    | '/app/admin/verification'
    | '/app/admin/whatsapp-templates'
    | '/app/companies/$company_id'
    | '/app/admin'
    | '/app/admin/companies/$company_id'
    | '/app/admin/investor-onboarding-jobs/$job_id'
    | '/app/admin/legal/$document_id'
    | '/app/admin/legal/acknowledgements'
    | '/app/admin/legal/new'
    | '/app/admin/users/$user_id'
    | '/app/admin/verification/audit-logs'
    | '/app/admin/verification/email-logs'
    | '/app/admin/verification/phone-logs'
    | '/app/admin/verification/settings'
    | '/app/admin/whatsapp-groups/$groupId'
    | '/app/sales/onboarding-jobs/$job_id'
    | '/app/admin/companies'
    | '/app/admin/investor-onboarding-jobs'
    | '/app/admin/legal'
    | '/app/admin/users'
    | '/app/admin/whatsapp-groups'
    | '/app/sales/onboarding-jobs'
    | '/app/companies/$company_id/onboarding/summary'
    | '/app/companies/$company_id/sections/$section_id'
    | '/app/companies/$company_id/onboarding'
    | '/app/companies/$company_id/sections/$section_id/dashboard'
    | '/app/companies/$company_id/sections/$section_id/new'
    | '/app/companies/$company_id/sections/$section_id/investor-chat/$thread_id'
    | '/app/companies/$company_id/sections/$section_id/threads/$thread_id'
  id:
    | '__root__'
    | '/_public'
    | '/app'
    | '/auth'
    | '/_public/about'
    | '/_public/contact'
    | '/_public/cookies-policy'
    | '/_public/fundraiser-connect'
    | '/_public/how-it-works'
    | '/_public/investor-connect'
    | '/_public/privacy'
    | '/_public/terms'
    | '/app/admin'
    | '/app/onboarding'
    | '/app/reviews'
    | '/app/sales'
    | '/app/settings'
    | '/auth/accept-legal'
    | '/auth/edit-email'
    | '/auth/edit-number'
    | '/auth/email-verification'
    | '/auth/forgotPassword'
    | '/auth/login'
    | '/auth/reset-password'
    | '/auth/signup'
    | '/auth/verify-method'
    | '/auth/verify-otp'
    | '/_public/'
    | '/app/'
    | '/app/admin/ai-usage'
    | '/app/admin/analytics'
    | '/app/admin/audit-logs'
    | '/app/admin/chat'
    | '/app/admin/companies'
    | '/app/admin/feedback'
    | '/app/admin/files'
    | '/app/admin/gdpr'
    | '/app/admin/investor-invites'
    | '/app/admin/investor-onboarding-jobs'
    | '/app/admin/investor-platform'
    | '/app/admin/legal'
    | '/app/admin/login-attempts'
    | '/app/admin/onboarding-answers'
    | '/app/admin/onboarding-questions'
    | '/app/admin/reviewers'
    | '/app/admin/roles'
    | '/app/admin/sales'
    | '/app/admin/sections'
    | '/app/admin/settings'
    | '/app/admin/system'
    | '/app/admin/users'
    | '/app/admin/verification'
    | '/app/admin/whatsapp-groups'
    | '/app/admin/whatsapp-templates'
    | '/app/companies/$company_id'
    | '/app/sales/onboarding-jobs'
    | '/app/admin/'
    | '/app/admin/companies/$company_id'
    | '/app/admin/investor-onboarding-jobs/$job_id'
    | '/app/admin/legal/$document_id'
    | '/app/admin/legal/acknowledgements'
    | '/app/admin/legal/new'
    | '/app/admin/users/$user_id'
    | '/app/admin/verification/audit-logs'
    | '/app/admin/verification/email-logs'
    | '/app/admin/verification/phone-logs'
    | '/app/admin/verification/settings'
    | '/app/admin/whatsapp-groups/$groupId'
    | '/app/companies/$company_id/onboarding'
    | '/app/sales/onboarding-jobs/$job_id'
    | '/app/admin/companies/'
    | '/app/admin/investor-onboarding-jobs/'
    | '/app/admin/legal/'
    | '/app/admin/users/'
    | '/app/admin/whatsapp-groups/'
    | '/app/sales/onboarding-jobs/'
    | '/app/companies/$company_id/onboarding/summary'
    | '/app/companies/$company_id/sections/$section_id'
    | '/app/companies/$company_id/onboarding/'
    | '/app/companies/$company_id/sections/$section_id/dashboard'
    | '/app/companies/$company_id/sections/$section_id/new'
    | '/app/companies/$company_id/sections/$section_id/investor-chat/$thread_id'
    | '/app/companies/$company_id/sections/$section_id/threads/$thread_id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PublicRoute: typeof PublicRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/auth/verify-otp': {
      id: '/auth/verify-otp'
      path: '/verify-otp'
      fullPath: '/auth/verify-otp'
      preLoaderRoute: typeof AuthVerifyOtpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/verify-method': {
      id: '/auth/verify-method'
      path: '/verify-method'
      fullPath: '/auth/verify-method'
      preLoaderRoute: typeof AuthVerifyMethodRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/forgotPassword': {
      id: '/auth/forgotPassword'
      path: '/forgotPassword'
      fullPath: '/auth/forgotPassword'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/email-verification': {
      id: '/auth/email-verification'
      path: '/email-verification'
      fullPath: '/auth/email-verification'
      preLoaderRoute: typeof AuthEmailVerificationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/edit-number': {
      id: '/auth/edit-number'
      path: '/edit-number'
      fullPath: '/auth/edit-number'
      preLoaderRoute: typeof AuthEditNumberRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/edit-email': {
      id: '/auth/edit-email'
      path: '/edit-email'
      fullPath: '/auth/edit-email'
      preLoaderRoute: typeof AuthEditEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/accept-legal': {
      id: '/auth/accept-legal'
      path: '/accept-legal'
      fullPath: '/auth/accept-legal'
      preLoaderRoute: typeof AuthAcceptLegalRouteImport
      parentRoute: typeof AuthRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/sales': {
      id: '/app/sales'
      path: '/sales'
      fullPath: '/app/sales'
      preLoaderRoute: typeof AppSalesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/reviews': {
      id: '/app/reviews'
      path: '/reviews'
      fullPath: '/app/reviews'
      preLoaderRoute: typeof AppReviewsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/onboarding': {
      id: '/app/onboarding'
      path: '/onboarding'
      fullPath: '/app/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin': {
      id: '/app/admin'
      path: '/admin'
      fullPath: '/app/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/terms': {
      id: '/_public/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof PublicTermsRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/privacy': {
      id: '/_public/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PublicPrivacyRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/investor-connect': {
      id: '/_public/investor-connect'
      path: '/investor-connect'
      fullPath: '/investor-connect'
      preLoaderRoute: typeof PublicInvestorConnectRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/how-it-works': {
      id: '/_public/how-it-works'
      path: '/how-it-works'
      fullPath: '/how-it-works'
      preLoaderRoute: typeof PublicHowItWorksRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/fundraiser-connect': {
      id: '/_public/fundraiser-connect'
      path: '/fundraiser-connect'
      fullPath: '/fundraiser-connect'
      preLoaderRoute: typeof PublicFundraiserConnectRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/cookies-policy': {
      id: '/_public/cookies-policy'
      path: '/cookies-policy'
      fullPath: '/cookies-policy'
      preLoaderRoute: typeof PublicCookiesPolicyRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/contact': {
      id: '/_public/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof PublicContactRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/about': {
      id: '/_public/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof PublicAboutRouteImport
      parentRoute: typeof PublicRoute
    }
    '/app/admin/': {
      id: '/app/admin/'
      path: '/'
      fullPath: '/app/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/sales/onboarding-jobs': {
      id: '/app/sales/onboarding-jobs'
      path: '/onboarding-jobs'
      fullPath: '/app/sales/onboarding-jobs'
      preLoaderRoute: typeof AppSalesOnboardingJobsRouteImport
      parentRoute: typeof AppSalesRoute
    }
    '/app/companies/$company_id': {
      id: '/app/companies/$company_id'
      path: '/companies/$company_id'
      fullPath: '/app/companies/$company_id'
      preLoaderRoute: typeof AppCompaniesCompany_idRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/whatsapp-templates': {
      id: '/app/admin/whatsapp-templates'
      path: '/whatsapp-templates'
      fullPath: '/app/admin/whatsapp-templates'
      preLoaderRoute: typeof AppAdminWhatsappTemplatesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/whatsapp-groups': {
      id: '/app/admin/whatsapp-groups'
      path: '/whatsapp-groups'
      fullPath: '/app/admin/whatsapp-groups'
      preLoaderRoute: typeof AppAdminWhatsappGroupsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/verification': {
      id: '/app/admin/verification'
      path: '/verification'
      fullPath: '/app/admin/verification'
      preLoaderRoute: typeof AppAdminVerificationRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/users': {
      id: '/app/admin/users'
      path: '/users'
      fullPath: '/app/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/system': {
      id: '/app/admin/system'
      path: '/system'
      fullPath: '/app/admin/system'
      preLoaderRoute: typeof AppAdminSystemRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/settings': {
      id: '/app/admin/settings'
      path: '/settings'
      fullPath: '/app/admin/settings'
      preLoaderRoute: typeof AppAdminSettingsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/sections': {
      id: '/app/admin/sections'
      path: '/sections'
      fullPath: '/app/admin/sections'
      preLoaderRoute: typeof AppAdminSectionsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/sales': {
      id: '/app/admin/sales'
      path: '/sales'
      fullPath: '/app/admin/sales'
      preLoaderRoute: typeof AppAdminSalesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/roles': {
      id: '/app/admin/roles'
      path: '/roles'
      fullPath: '/app/admin/roles'
      preLoaderRoute: typeof AppAdminRolesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/reviewers': {
      id: '/app/admin/reviewers'
      path: '/reviewers'
      fullPath: '/app/admin/reviewers'
      preLoaderRoute: typeof AppAdminReviewersRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/onboarding-questions': {
      id: '/app/admin/onboarding-questions'
      path: '/onboarding-questions'
      fullPath: '/app/admin/onboarding-questions'
      preLoaderRoute: typeof AppAdminOnboardingQuestionsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/onboarding-answers': {
      id: '/app/admin/onboarding-answers'
      path: '/onboarding-answers'
      fullPath: '/app/admin/onboarding-answers'
      preLoaderRoute: typeof AppAdminOnboardingAnswersRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/login-attempts': {
      id: '/app/admin/login-attempts'
      path: '/login-attempts'
      fullPath: '/app/admin/login-attempts'
      preLoaderRoute: typeof AppAdminLoginAttemptsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/legal': {
      id: '/app/admin/legal'
      path: '/legal'
      fullPath: '/app/admin/legal'
      preLoaderRoute: typeof AppAdminLegalRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/investor-platform': {
      id: '/app/admin/investor-platform'
      path: '/investor-platform'
      fullPath: '/app/admin/investor-platform'
      preLoaderRoute: typeof AppAdminInvestorPlatformRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/investor-onboarding-jobs': {
      id: '/app/admin/investor-onboarding-jobs'
      path: '/investor-onboarding-jobs'
      fullPath: '/app/admin/investor-onboarding-jobs'
      preLoaderRoute: typeof AppAdminInvestorOnboardingJobsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/investor-invites': {
      id: '/app/admin/investor-invites'
      path: '/investor-invites'
      fullPath: '/app/admin/investor-invites'
      preLoaderRoute: typeof AppAdminInvestorInvitesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/gdpr': {
      id: '/app/admin/gdpr'
      path: '/gdpr'
      fullPath: '/app/admin/gdpr'
      preLoaderRoute: typeof AppAdminGdprRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/files': {
      id: '/app/admin/files'
      path: '/files'
      fullPath: '/app/admin/files'
      preLoaderRoute: typeof AppAdminFilesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/feedback': {
      id: '/app/admin/feedback'
      path: '/feedback'
      fullPath: '/app/admin/feedback'
      preLoaderRoute: typeof AppAdminFeedbackRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/companies': {
      id: '/app/admin/companies'
      path: '/companies'
      fullPath: '/app/admin/companies'
      preLoaderRoute: typeof AppAdminCompaniesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/chat': {
      id: '/app/admin/chat'
      path: '/chat'
      fullPath: '/app/admin/chat'
      preLoaderRoute: typeof AppAdminChatRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/audit-logs': {
      id: '/app/admin/audit-logs'
      path: '/audit-logs'
      fullPath: '/app/admin/audit-logs'
      preLoaderRoute: typeof AppAdminAuditLogsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/analytics': {
      id: '/app/admin/analytics'
      path: '/analytics'
      fullPath: '/app/admin/analytics'
      preLoaderRoute: typeof AppAdminAnalyticsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/ai-usage': {
      id: '/app/admin/ai-usage'
      path: '/ai-usage'
      fullPath: '/app/admin/ai-usage'
      preLoaderRoute: typeof AppAdminAiUsageRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/sales/onboarding-jobs/': {
      id: '/app/sales/onboarding-jobs/'
      path: '/'
      fullPath: '/app/sales/onboarding-jobs/'
      preLoaderRoute: typeof AppSalesOnboardingJobsIndexRouteImport
      parentRoute: typeof AppSalesOnboardingJobsRoute
    }
    '/app/admin/whatsapp-groups/': {
      id: '/app/admin/whatsapp-groups/'
      path: '/'
      fullPath: '/app/admin/whatsapp-groups/'
      preLoaderRoute: typeof AppAdminWhatsappGroupsIndexRouteImport
      parentRoute: typeof AppAdminWhatsappGroupsRoute
    }
    '/app/admin/users/': {
      id: '/app/admin/users/'
      path: '/'
      fullPath: '/app/admin/users/'
      preLoaderRoute: typeof AppAdminUsersIndexRouteImport
      parentRoute: typeof AppAdminUsersRoute
    }
    '/app/admin/legal/': {
      id: '/app/admin/legal/'
      path: '/'
      fullPath: '/app/admin/legal/'
      preLoaderRoute: typeof AppAdminLegalIndexRouteImport
      parentRoute: typeof AppAdminLegalRoute
    }
    '/app/admin/investor-onboarding-jobs/': {
      id: '/app/admin/investor-onboarding-jobs/'
      path: '/'
      fullPath: '/app/admin/investor-onboarding-jobs/'
      preLoaderRoute: typeof AppAdminInvestorOnboardingJobsIndexRouteImport
      parentRoute: typeof AppAdminInvestorOnboardingJobsRoute
    }
    '/app/admin/companies/': {
      id: '/app/admin/companies/'
      path: '/'
      fullPath: '/app/admin/companies/'
      preLoaderRoute: typeof AppAdminCompaniesIndexRouteImport
      parentRoute: typeof AppAdminCompaniesRoute
    }
    '/app/sales/onboarding-jobs/$job_id': {
      id: '/app/sales/onboarding-jobs/$job_id'
      path: '/$job_id'
      fullPath: '/app/sales/onboarding-jobs/$job_id'
      preLoaderRoute: typeof AppSalesOnboardingJobsJob_idRouteImport
      parentRoute: typeof AppSalesOnboardingJobsRoute
    }
    '/app/companies/$company_id/onboarding': {
      id: '/app/companies/$company_id/onboarding'
      path: '/onboarding'
      fullPath: '/app/companies/$company_id/onboarding'
      preLoaderRoute: typeof AppCompaniesCompany_idOnboardingRouteImport
      parentRoute: typeof AppCompaniesCompany_idRoute
    }
    '/app/admin/whatsapp-groups/$groupId': {
      id: '/app/admin/whatsapp-groups/$groupId'
      path: '/$groupId'
      fullPath: '/app/admin/whatsapp-groups/$groupId'
      preLoaderRoute: typeof AppAdminWhatsappGroupsGroupIdRouteImport
      parentRoute: typeof AppAdminWhatsappGroupsRoute
    }
    '/app/admin/verification/settings': {
      id: '/app/admin/verification/settings'
      path: '/settings'
      fullPath: '/app/admin/verification/settings'
      preLoaderRoute: typeof AppAdminVerificationSettingsRouteImport
      parentRoute: typeof AppAdminVerificationRoute
    }
    '/app/admin/verification/phone-logs': {
      id: '/app/admin/verification/phone-logs'
      path: '/phone-logs'
      fullPath: '/app/admin/verification/phone-logs'
      preLoaderRoute: typeof AppAdminVerificationPhoneLogsRouteImport
      parentRoute: typeof AppAdminVerificationRoute
    }
    '/app/admin/verification/email-logs': {
      id: '/app/admin/verification/email-logs'
      path: '/email-logs'
      fullPath: '/app/admin/verification/email-logs'
      preLoaderRoute: typeof AppAdminVerificationEmailLogsRouteImport
      parentRoute: typeof AppAdminVerificationRoute
    }
    '/app/admin/verification/audit-logs': {
      id: '/app/admin/verification/audit-logs'
      path: '/audit-logs'
      fullPath: '/app/admin/verification/audit-logs'
      preLoaderRoute: typeof AppAdminVerificationAuditLogsRouteImport
      parentRoute: typeof AppAdminVerificationRoute
    }
    '/app/admin/users/$user_id': {
      id: '/app/admin/users/$user_id'
      path: '/$user_id'
      fullPath: '/app/admin/users/$user_id'
      preLoaderRoute: typeof AppAdminUsersUser_idRouteImport
      parentRoute: typeof AppAdminUsersRoute
    }
    '/app/admin/legal/new': {
      id: '/app/admin/legal/new'
      path: '/new'
      fullPath: '/app/admin/legal/new'
      preLoaderRoute: typeof AppAdminLegalNewRouteImport
      parentRoute: typeof AppAdminLegalRoute
    }
    '/app/admin/legal/acknowledgements': {
      id: '/app/admin/legal/acknowledgements'
      path: '/acknowledgements'
      fullPath: '/app/admin/legal/acknowledgements'
      preLoaderRoute: typeof AppAdminLegalAcknowledgementsRouteImport
      parentRoute: typeof AppAdminLegalRoute
    }
    '/app/admin/legal/$document_id': {
      id: '/app/admin/legal/$document_id'
      path: '/$document_id'
      fullPath: '/app/admin/legal/$document_id'
      preLoaderRoute: typeof AppAdminLegalDocument_idRouteImport
      parentRoute: typeof AppAdminLegalRoute
    }
    '/app/admin/investor-onboarding-jobs/$job_id': {
      id: '/app/admin/investor-onboarding-jobs/$job_id'
      path: '/$job_id'
      fullPath: '/app/admin/investor-onboarding-jobs/$job_id'
      preLoaderRoute: typeof AppAdminInvestorOnboardingJobsJob_idRouteImport
      parentRoute: typeof AppAdminInvestorOnboardingJobsRoute
    }
    '/app/admin/companies/$company_id': {
      id: '/app/admin/companies/$company_id'
      path: '/$company_id'
      fullPath: '/app/admin/companies/$company_id'
      preLoaderRoute: typeof AppAdminCompaniesCompany_idRouteImport
      parentRoute: typeof AppAdminCompaniesRoute
    }
    '/app/companies/$company_id/onboarding/': {
      id: '/app/companies/$company_id/onboarding/'
      path: '/'
      fullPath: '/app/companies/$company_id/onboarding/'
      preLoaderRoute: typeof AppCompaniesCompany_idOnboardingIndexRouteImport
      parentRoute: typeof AppCompaniesCompany_idOnboardingRoute
    }
    '/app/companies/$company_id/sections/$section_id': {
      id: '/app/companies/$company_id/sections/$section_id'
      path: '/sections/$section_id'
      fullPath: '/app/companies/$company_id/sections/$section_id'
      preLoaderRoute: typeof AppCompaniesCompany_idSectionsSection_idRouteImport
      parentRoute: typeof AppCompaniesCompany_idRoute
    }
    '/app/companies/$company_id/onboarding/summary': {
      id: '/app/companies/$company_id/onboarding/summary'
      path: '/summary'
      fullPath: '/app/companies/$company_id/onboarding/summary'
      preLoaderRoute: typeof AppCompaniesCompany_idOnboardingSummaryRouteImport
      parentRoute: typeof AppCompaniesCompany_idOnboardingRoute
    }
    '/app/companies/$company_id/sections/$section_id/new': {
      id: '/app/companies/$company_id/sections/$section_id/new'
      path: '/new'
      fullPath: '/app/companies/$company_id/sections/$section_id/new'
      preLoaderRoute: typeof AppCompaniesCompany_idSectionsSection_idNewRouteImport
      parentRoute: typeof AppCompaniesCompany_idSectionsSection_idRoute
    }
    '/app/companies/$company_id/sections/$section_id/dashboard': {
      id: '/app/companies/$company_id/sections/$section_id/dashboard'
      path: '/dashboard'
      fullPath: '/app/companies/$company_id/sections/$section_id/dashboard'
      preLoaderRoute: typeof AppCompaniesCompany_idSectionsSection_idDashboardRouteImport
      parentRoute: typeof AppCompaniesCompany_idSectionsSection_idRoute
    }
    '/app/companies/$company_id/sections/$section_id/threads/$thread_id': {
      id: '/app/companies/$company_id/sections/$section_id/threads/$thread_id'
      path: '/threads/$thread_id'
      fullPath: '/app/companies/$company_id/sections/$section_id/threads/$thread_id'
      preLoaderRoute: typeof AppCompaniesCompany_idSectionsSection_idThreadsThread_idRouteImport
      parentRoute: typeof AppCompaniesCompany_idSectionsSection_idRoute
    }
    '/app/companies/$company_id/sections/$section_id/investor-chat/$thread_id': {
      id: '/app/companies/$company_id/sections/$section_id/investor-chat/$thread_id'
      path: '/investor-chat/$thread_id'
      fullPath: '/app/companies/$company_id/sections/$section_id/investor-chat/$thread_id'
      preLoaderRoute: typeof AppCompaniesCompany_idSectionsSection_idInvestorChatThread_idRouteImport
      parentRoute: typeof AppCompaniesCompany_idSectionsSection_idRoute
    }
  }
}

interface PublicRouteChildren {
  PublicAboutRoute: typeof PublicAboutRoute
  PublicContactRoute: typeof PublicContactRoute
  PublicCookiesPolicyRoute: typeof PublicCookiesPolicyRoute
  PublicFundraiserConnectRoute: typeof PublicFundraiserConnectRoute
  PublicHowItWorksRoute: typeof PublicHowItWorksRoute
  PublicInvestorConnectRoute: typeof PublicInvestorConnectRoute
  PublicPrivacyRoute: typeof PublicPrivacyRoute
  PublicTermsRoute: typeof PublicTermsRoute
  PublicIndexRoute: typeof PublicIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicAboutRoute: PublicAboutRoute,
  PublicContactRoute: PublicContactRoute,
  PublicCookiesPolicyRoute: PublicCookiesPolicyRoute,
  PublicFundraiserConnectRoute: PublicFundraiserConnectRoute,
  PublicHowItWorksRoute: PublicHowItWorksRoute,
  PublicInvestorConnectRoute: PublicInvestorConnectRoute,
  PublicPrivacyRoute: PublicPrivacyRoute,
  PublicTermsRoute: PublicTermsRoute,
  PublicIndexRoute: PublicIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface AppAdminCompaniesRouteChildren {
  AppAdminCompaniesCompany_idRoute: typeof AppAdminCompaniesCompany_idRoute
  AppAdminCompaniesIndexRoute: typeof AppAdminCompaniesIndexRoute
}

const AppAdminCompaniesRouteChildren: AppAdminCompaniesRouteChildren = {
  AppAdminCompaniesCompany_idRoute: AppAdminCompaniesCompany_idRoute,
  AppAdminCompaniesIndexRoute: AppAdminCompaniesIndexRoute,
}

const AppAdminCompaniesRouteWithChildren =
  AppAdminCompaniesRoute._addFileChildren(AppAdminCompaniesRouteChildren)

interface AppAdminInvestorOnboardingJobsRouteChildren {
  AppAdminInvestorOnboardingJobsJob_idRoute: typeof AppAdminInvestorOnboardingJobsJob_idRoute
  AppAdminInvestorOnboardingJobsIndexRoute: typeof AppAdminInvestorOnboardingJobsIndexRoute
}

const AppAdminInvestorOnboardingJobsRouteChildren: AppAdminInvestorOnboardingJobsRouteChildren =
  {
    AppAdminInvestorOnboardingJobsJob_idRoute:
      AppAdminInvestorOnboardingJobsJob_idRoute,
    AppAdminInvestorOnboardingJobsIndexRoute:
      AppAdminInvestorOnboardingJobsIndexRoute,
  }

const AppAdminInvestorOnboardingJobsRouteWithChildren =
  AppAdminInvestorOnboardingJobsRoute._addFileChildren(
    AppAdminInvestorOnboardingJobsRouteChildren,
  )

interface AppAdminLegalRouteChildren {
  AppAdminLegalDocument_idRoute: typeof AppAdminLegalDocument_idRoute
  AppAdminLegalAcknowledgementsRoute: typeof AppAdminLegalAcknowledgementsRoute
  AppAdminLegalNewRoute: typeof AppAdminLegalNewRoute
  AppAdminLegalIndexRoute: typeof AppAdminLegalIndexRoute
}

const AppAdminLegalRouteChildren: AppAdminLegalRouteChildren = {
  AppAdminLegalDocument_idRoute: AppAdminLegalDocument_idRoute,
  AppAdminLegalAcknowledgementsRoute: AppAdminLegalAcknowledgementsRoute,
  AppAdminLegalNewRoute: AppAdminLegalNewRoute,
  AppAdminLegalIndexRoute: AppAdminLegalIndexRoute,
}

const AppAdminLegalRouteWithChildren = AppAdminLegalRoute._addFileChildren(
  AppAdminLegalRouteChildren,
)

interface AppAdminUsersRouteChildren {
  AppAdminUsersUser_idRoute: typeof AppAdminUsersUser_idRoute
  AppAdminUsersIndexRoute: typeof AppAdminUsersIndexRoute
}

const AppAdminUsersRouteChildren: AppAdminUsersRouteChildren = {
  AppAdminUsersUser_idRoute: AppAdminUsersUser_idRoute,
  AppAdminUsersIndexRoute: AppAdminUsersIndexRoute,
}

const AppAdminUsersRouteWithChildren = AppAdminUsersRoute._addFileChildren(
  AppAdminUsersRouteChildren,
)

interface AppAdminVerificationRouteChildren {
  AppAdminVerificationAuditLogsRoute: typeof AppAdminVerificationAuditLogsRoute
  AppAdminVerificationEmailLogsRoute: typeof AppAdminVerificationEmailLogsRoute
  AppAdminVerificationPhoneLogsRoute: typeof AppAdminVerificationPhoneLogsRoute
  AppAdminVerificationSettingsRoute: typeof AppAdminVerificationSettingsRoute
}

const AppAdminVerificationRouteChildren: AppAdminVerificationRouteChildren = {
  AppAdminVerificationAuditLogsRoute: AppAdminVerificationAuditLogsRoute,
  AppAdminVerificationEmailLogsRoute: AppAdminVerificationEmailLogsRoute,
  AppAdminVerificationPhoneLogsRoute: AppAdminVerificationPhoneLogsRoute,
  AppAdminVerificationSettingsRoute: AppAdminVerificationSettingsRoute,
}

const AppAdminVerificationRouteWithChildren =
  AppAdminVerificationRoute._addFileChildren(AppAdminVerificationRouteChildren)

interface AppAdminWhatsappGroupsRouteChildren {
  AppAdminWhatsappGroupsGroupIdRoute: typeof AppAdminWhatsappGroupsGroupIdRoute
  AppAdminWhatsappGroupsIndexRoute: typeof AppAdminWhatsappGroupsIndexRoute
}

const AppAdminWhatsappGroupsRouteChildren: AppAdminWhatsappGroupsRouteChildren =
  {
    AppAdminWhatsappGroupsGroupIdRoute: AppAdminWhatsappGroupsGroupIdRoute,
    AppAdminWhatsappGroupsIndexRoute: AppAdminWhatsappGroupsIndexRoute,
  }

const AppAdminWhatsappGroupsRouteWithChildren =
  AppAdminWhatsappGroupsRoute._addFileChildren(
    AppAdminWhatsappGroupsRouteChildren,
  )

interface AppAdminRouteChildren {
  AppAdminAiUsageRoute: typeof AppAdminAiUsageRoute
  AppAdminAnalyticsRoute: typeof AppAdminAnalyticsRoute
  AppAdminAuditLogsRoute: typeof AppAdminAuditLogsRoute
  AppAdminChatRoute: typeof AppAdminChatRoute
  AppAdminCompaniesRoute: typeof AppAdminCompaniesRouteWithChildren
  AppAdminFeedbackRoute: typeof AppAdminFeedbackRoute
  AppAdminFilesRoute: typeof AppAdminFilesRoute
  AppAdminGdprRoute: typeof AppAdminGdprRoute
  AppAdminInvestorInvitesRoute: typeof AppAdminInvestorInvitesRoute
  AppAdminInvestorOnboardingJobsRoute: typeof AppAdminInvestorOnboardingJobsRouteWithChildren
  AppAdminInvestorPlatformRoute: typeof AppAdminInvestorPlatformRoute
  AppAdminLegalRoute: typeof AppAdminLegalRouteWithChildren
  AppAdminLoginAttemptsRoute: typeof AppAdminLoginAttemptsRoute
  AppAdminOnboardingAnswersRoute: typeof AppAdminOnboardingAnswersRoute
  AppAdminOnboardingQuestionsRoute: typeof AppAdminOnboardingQuestionsRoute
  AppAdminReviewersRoute: typeof AppAdminReviewersRoute
  AppAdminRolesRoute: typeof AppAdminRolesRoute
  AppAdminSalesRoute: typeof AppAdminSalesRoute
  AppAdminSectionsRoute: typeof AppAdminSectionsRoute
  AppAdminSettingsRoute: typeof AppAdminSettingsRoute
  AppAdminSystemRoute: typeof AppAdminSystemRoute
  AppAdminUsersRoute: typeof AppAdminUsersRouteWithChildren
  AppAdminVerificationRoute: typeof AppAdminVerificationRouteWithChildren
  AppAdminWhatsappGroupsRoute: typeof AppAdminWhatsappGroupsRouteWithChildren
  AppAdminWhatsappTemplatesRoute: typeof AppAdminWhatsappTemplatesRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminAiUsageRoute: AppAdminAiUsageRoute,
  AppAdminAnalyticsRoute: AppAdminAnalyticsRoute,
  AppAdminAuditLogsRoute: AppAdminAuditLogsRoute,
  AppAdminChatRoute: AppAdminChatRoute,
  AppAdminCompaniesRoute: AppAdminCompaniesRouteWithChildren,
  AppAdminFeedbackRoute: AppAdminFeedbackRoute,
  AppAdminFilesRoute: AppAdminFilesRoute,
  AppAdminGdprRoute: AppAdminGdprRoute,
  AppAdminInvestorInvitesRoute: AppAdminInvestorInvitesRoute,
  AppAdminInvestorOnboardingJobsRoute:
    AppAdminInvestorOnboardingJobsRouteWithChildren,
  AppAdminInvestorPlatformRoute: AppAdminInvestorPlatformRoute,
  AppAdminLegalRoute: AppAdminLegalRouteWithChildren,
  AppAdminLoginAttemptsRoute: AppAdminLoginAttemptsRoute,
  AppAdminOnboardingAnswersRoute: AppAdminOnboardingAnswersRoute,
  AppAdminOnboardingQuestionsRoute: AppAdminOnboardingQuestionsRoute,
  AppAdminReviewersRoute: AppAdminReviewersRoute,
  AppAdminRolesRoute: AppAdminRolesRoute,
  AppAdminSalesRoute: AppAdminSalesRoute,
  AppAdminSectionsRoute: AppAdminSectionsRoute,
  AppAdminSettingsRoute: AppAdminSettingsRoute,
  AppAdminSystemRoute: AppAdminSystemRoute,
  AppAdminUsersRoute: AppAdminUsersRouteWithChildren,
  AppAdminVerificationRoute: AppAdminVerificationRouteWithChildren,
  AppAdminWhatsappGroupsRoute: AppAdminWhatsappGroupsRouteWithChildren,
  AppAdminWhatsappTemplatesRoute: AppAdminWhatsappTemplatesRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppSalesOnboardingJobsRouteChildren {
  AppSalesOnboardingJobsJob_idRoute: typeof AppSalesOnboardingJobsJob_idRoute
  AppSalesOnboardingJobsIndexRoute: typeof AppSalesOnboardingJobsIndexRoute
}

const AppSalesOnboardingJobsRouteChildren: AppSalesOnboardingJobsRouteChildren =
  {
    AppSalesOnboardingJobsJob_idRoute: AppSalesOnboardingJobsJob_idRoute,
    AppSalesOnboardingJobsIndexRoute: AppSalesOnboardingJobsIndexRoute,
  }

const AppSalesOnboardingJobsRouteWithChildren =
  AppSalesOnboardingJobsRoute._addFileChildren(
    AppSalesOnboardingJobsRouteChildren,
  )

interface AppSalesRouteChildren {
  AppSalesOnboardingJobsRoute: typeof AppSalesOnboardingJobsRouteWithChildren
}

const AppSalesRouteChildren: AppSalesRouteChildren = {
  AppSalesOnboardingJobsRoute: AppSalesOnboardingJobsRouteWithChildren,
}

const AppSalesRouteWithChildren = AppSalesRoute._addFileChildren(
  AppSalesRouteChildren,
)

interface AppCompaniesCompany_idOnboardingRouteChildren {
  AppCompaniesCompany_idOnboardingSummaryRoute: typeof AppCompaniesCompany_idOnboardingSummaryRoute
  AppCompaniesCompany_idOnboardingIndexRoute: typeof AppCompaniesCompany_idOnboardingIndexRoute
}

const AppCompaniesCompany_idOnboardingRouteChildren: AppCompaniesCompany_idOnboardingRouteChildren =
  {
    AppCompaniesCompany_idOnboardingSummaryRoute:
      AppCompaniesCompany_idOnboardingSummaryRoute,
    AppCompaniesCompany_idOnboardingIndexRoute:
      AppCompaniesCompany_idOnboardingIndexRoute,
  }

const AppCompaniesCompany_idOnboardingRouteWithChildren =
  AppCompaniesCompany_idOnboardingRoute._addFileChildren(
    AppCompaniesCompany_idOnboardingRouteChildren,
  )

interface AppCompaniesCompany_idSectionsSection_idRouteChildren {
  AppCompaniesCompany_idSectionsSection_idDashboardRoute: typeof AppCompaniesCompany_idSectionsSection_idDashboardRoute
  AppCompaniesCompany_idSectionsSection_idNewRoute: typeof AppCompaniesCompany_idSectionsSection_idNewRoute
  AppCompaniesCompany_idSectionsSection_idInvestorChatThread_idRoute: typeof AppCompaniesCompany_idSectionsSection_idInvestorChatThread_idRoute
  AppCompaniesCompany_idSectionsSection_idThreadsThread_idRoute: typeof AppCompaniesCompany_idSectionsSection_idThreadsThread_idRoute
}

const AppCompaniesCompany_idSectionsSection_idRouteChildren: AppCompaniesCompany_idSectionsSection_idRouteChildren =
  {
    AppCompaniesCompany_idSectionsSection_idDashboardRoute:
      AppCompaniesCompany_idSectionsSection_idDashboardRoute,
    AppCompaniesCompany_idSectionsSection_idNewRoute:
      AppCompaniesCompany_idSectionsSection_idNewRoute,
    AppCompaniesCompany_idSectionsSection_idInvestorChatThread_idRoute:
      AppCompaniesCompany_idSectionsSection_idInvestorChatThread_idRoute,
    AppCompaniesCompany_idSectionsSection_idThreadsThread_idRoute:
      AppCompaniesCompany_idSectionsSection_idThreadsThread_idRoute,
  }

const AppCompaniesCompany_idSectionsSection_idRouteWithChildren =
  AppCompaniesCompany_idSectionsSection_idRoute._addFileChildren(
    AppCompaniesCompany_idSectionsSection_idRouteChildren,
  )

interface AppCompaniesCompany_idRouteChildren {
  AppCompaniesCompany_idOnboardingRoute: typeof AppCompaniesCompany_idOnboardingRouteWithChildren
  AppCompaniesCompany_idSectionsSection_idRoute: typeof AppCompaniesCompany_idSectionsSection_idRouteWithChildren
}

const AppCompaniesCompany_idRouteChildren: AppCompaniesCompany_idRouteChildren =
  {
    AppCompaniesCompany_idOnboardingRoute:
      AppCompaniesCompany_idOnboardingRouteWithChildren,
    AppCompaniesCompany_idSectionsSection_idRoute:
      AppCompaniesCompany_idSectionsSection_idRouteWithChildren,
  }

const AppCompaniesCompany_idRouteWithChildren =
  AppCompaniesCompany_idRoute._addFileChildren(
    AppCompaniesCompany_idRouteChildren,
  )

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppOnboardingRoute: typeof AppOnboardingRoute
  AppReviewsRoute: typeof AppReviewsRoute
  AppSalesRoute: typeof AppSalesRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCompaniesCompany_idRoute: typeof AppCompaniesCompany_idRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,
  AppOnboardingRoute: AppOnboardingRoute,
  AppReviewsRoute: AppReviewsRoute,
  AppSalesRoute: AppSalesRouteWithChildren,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppCompaniesCompany_idRoute: AppCompaniesCompany_idRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthAcceptLegalRoute: typeof AuthAcceptLegalRoute
  AuthEditEmailRoute: typeof AuthEditEmailRoute
  AuthEditNumberRoute: typeof AuthEditNumberRoute
  AuthEmailVerificationRoute: typeof AuthEmailVerificationRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthVerifyMethodRoute: typeof AuthVerifyMethodRoute
  AuthVerifyOtpRoute: typeof AuthVerifyOtpRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAcceptLegalRoute: AuthAcceptLegalRoute,
  AuthEditEmailRoute: AuthEditEmailRoute,
  AuthEditNumberRoute: AuthEditNumberRoute,
  AuthEmailVerificationRoute: AuthEmailVerificationRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthVerifyMethodRoute: AuthVerifyMethodRoute,
  AuthVerifyOtpRoute: AuthVerifyOtpRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  PublicRoute: PublicRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
